import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { Logo, Loading } from "../components/shared";
import { Seo, SITE_URL } from "../components/Seo";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { BookOpen, ArrowRight, Search } from "lucide-react";

export default function KnowledgePublic() {
  const navigate = useNavigate();
  const [articles, setArticles] = useState(null);
  const [q, setQ] = useState("");

  useEffect(() => { api.get("/public/knowledge").then((r) => setArticles(r.data)).catch(() => setArticles([])); }, []);
  const filtered = (articles || []).filter((a) => a.title.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="min-h-screen bg-background">
      <Seo
        title="Housing Society Knowledge Centre — Ask SocietyMitra"
        description="Clear, factual answers on Indian cooperative housing society matters — bye-laws, AGM/SGM, maintenance, audits, parking, redevelopment and committee powers. General information from MySocietyMitra."
        path="/knowledge"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          "name": "Housing Society Knowledge Centre",
          "url": `${SITE_URL}/knowledge`,
          "isPartOf": { "@type": "WebSite", "name": "MySocietyMitra", "url": SITE_URL },
        }}
      />
      <header className="sticky top-0 z-50 glass border-b border-white/40">
        <div className="max-w-6xl mx-auto px-5 h-16 flex items-center justify-between">
          <Logo />
          <Button onClick={() => navigate("/login")} className="rounded-full" data-testid="knowledge-login">Start Free</Button>
        </div>
      </header>
      <div className="max-w-6xl mx-auto px-5 py-14">
        <div className="inline-flex items-center gap-2 text-xs font-semibold text-secondary bg-secondary/10 rounded-full px-3 py-1"><BookOpen className="w-3.5 h-3.5" /> Housing Society Knowledge Centre</div>
        <h1 className="font-display text-4xl md:text-5xl font-black tracking-tight mt-4">Ask MySocietyMitra</h1>
        <p className="text-muted-foreground mt-3 max-w-2xl">Clear, factual information about cooperative housing society matters. General information only — not legal advice.</p>
        <div className="relative mt-6 max-w-md">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search articles..." className="pl-9 rounded-full" data-testid="knowledge-search" />
        </div>

        {!articles ? <Loading /> : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mt-10">
            {filtered.map((a) => (
              <Link key={a.slug} to={`/knowledge/${a.slug}`} data-testid={`kb-card-${a.slug}`}
                className="bg-card rounded-xl border p-6 hover:-translate-y-1 hover:shadow-lg transition-transform group">
                <h3 className="font-display font-bold text-lg">{a.title}</h3>
                <p className="text-sm text-muted-foreground mt-2 line-clamp-3">{a.answer}</p>
                <div className="flex items-center gap-1 text-primary text-sm font-medium mt-4 group-hover:gap-2 transition-all">Read more <ArrowRight className="w-4 h-4" /></div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
